<div class="mat-elevation-z8">

    <div>
        <form [formGroup]="filterForm" (ngSubmit)="onFilter()" class="timesheet-form">
            <h5>User Report</h5>
            <div class="form-row">

                <!-- Category Selection -->
                <div class="field">
                    <mat-form-field appearance="outline">
                        <mat-label>Category</mat-label>
                        <mat-select formControlName="categoryIds" multiple="true"
                            (selectionChange)="onfilterCategorySelection($event.value)">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="categorySearch.multiFilterCtrl"
                                    [placeholderLabel]="'Search Category'" [noEntriesFoundLabel]="'No Category Found'"
                                    [showToggleAllCheckbox]="true"
                                    [toggleAllCheckboxIndeterminate]="categorySearch.isIndeterminate"
                                    [toggleAllCheckboxChecked]="categorySearch.isChecked"
                                    (toggleAll)="categorySearch.toggleSelectAll($event)"></ngx-mat-select-search>
                            </mat-option>
                            @for (category of categorySearch.filteredMulti | async; track category) {
                            <mat-option [value]="category.id">{{category.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Activity Selection -->
                <div class="field">
                    <mat-form-field appearance="outline">
                        <mat-label>Activity</mat-label>
                        <mat-select formControlName="activityIds" multiple="true">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="activitySearch.multiFilterCtrl"
                                    [placeholderLabel]="'Search Activity'" [noEntriesFoundLabel]="'No Activity Found'"
                                    [showToggleAllCheckbox]="true"
                                    [toggleAllCheckboxIndeterminate]="activitySearch.isIndeterminate"
                                    [toggleAllCheckboxChecked]="activitySearch.isChecked"
                                    (toggleAll)="activitySearch.toggleSelectAll($event)"></ngx-mat-select-search>
                            </mat-option>
                            @for (activity of activitySearch.filteredMulti | async; track activity) {
                            <mat-option [value]="activity.id">{{activity.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- User Selection -->
                @if(isAdmin || isTeamlead || isDepartmentAdmin){
                <div class="field">
                    <mat-form-field appearance="outline">
                        <mat-label>User</mat-label>
                        <mat-select formControlName="userIds" multiple="true">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="userSearch.multiFilterCtrl"
                                    [placeholderLabel]="'Search User'" [noEntriesFoundLabel]="'No User Found'"
                                    [showToggleAllCheckbox]="true"
                                    [toggleAllCheckboxIndeterminate]="userSearch.isIndeterminate"
                                    [toggleAllCheckboxChecked]="userSearch.isChecked"
                                    (toggleAll)="userSearch.toggleSelectAll($event)"></ngx-mat-select-search>
                            </mat-option>
                            @for (user of userSearch.filteredMulti | async; track user) {
                            <mat-option [value]="user.id">{{user.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                }

                <!-- Status Selection -->
                <div class="field">
                    <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status" multiple="true">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="statusSearch.multiFilterCtrl"
                                    [placeholderLabel]="'Search Status'" [noEntriesFoundLabel]="'No Status Found'"
                                    [showToggleAllCheckbox]="true"
                                    [toggleAllCheckboxIndeterminate]="statusSearch.isIndeterminate"
                                    [toggleAllCheckboxChecked]="statusSearch.isChecked"
                                    (toggleAll)="statusSearch.toggleSelectAll($event)"></ngx-mat-select-search>
                            </mat-option>
                            @for (status of statusSearch.filteredMulti | async; track status) {
                            <mat-option [value]="status.id">{{status.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="field">
                    <mat-form-field appearance="outline" class="start-date-field">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="field">
                    <mat-form-field appearance="outline" class="end-date-field">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <button mat-raised-button color="primary" type="submit">Filter</button>
                <button mat-raised-button color="primary" (click)="clearFilter()" type="button">Clear</button>
            </div>
        </form>

       <div class="export-total-wrapper">

    <button mat-raised-button color="primary" (click)="exportUserReprot()" type="button"
        class="excel-export-button" [disabled]="isExcelExporting">

        @if(isExcelExporting === true){
            <span class="spinner-size">
                <mat-spinner [diameter]="20"></mat-spinner>
            </span>
        }

        {{exportButtonText}}
    </button>

    <div class="total-hours-container">
        <span class="total-label">Total Hours:</span>
        <span class="total-value">{{ getTotalHours() }} hrs</span>
    </div>

</div>



    <div class="table-container">
       <table mat-table [dataSource]="userReport" class="my-table">

    <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef>Employee</th>
        <td mat-cell *matCellDef="let element">
            {{ element.fullName }}
        </td>
    </ng-container>

    <ng-container matColumnDef="workDate">
        <th mat-header-cell *matHeaderCellDef>Work Date</th>
        <td mat-cell *matCellDef="let element">
            {{ element.workDate | date:'dd-MM-yyyy' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="day">
        <th mat-header-cell *matHeaderCellDef>Work Day</th>
        <td mat-cell *matCellDef="let element">
            {{ element.day }}
        </td>
    </ng-container>

    <ng-container matColumnDef="noOfHours">
        <th mat-header-cell *matHeaderCellDef>No Of Hours</th>
        <td mat-cell *matCellDef="let element">
            {{ element.noOfHours }}
        </td>
    </ng-container>

    <ng-container matColumnDef="workDetails">
        <th mat-header-cell *matHeaderCellDef>Work Details</th>
        <td mat-cell *matCellDef="let element" class="work-details-cell">
            <span [innerHTML]="formatWorkDetails(element.workDetails)"></span>
        </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
            {{ element.status == null ? timeSheetStatus[0].name : timeSheetStatus[element.status].name }}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
            <button mat-raised-button color="primary" (click)="onView(element)">View</button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
    </div>
</div>